module.exports = __webpack_public_path__ + "static/media/playmaker-of-the-season.a7d086bd.png";